import { ICourse } from '@/shared/ICourse';
import { CourseStorageService } from '../services/CourseStorageService';
import { CourseDialog } from './CourseDialog';
import { ChangesService } from '@/shared/ChangesService';

export const EditCourseDialog = (props: {
  onClose: () => void;
  onCourseUpdated?: (course: ICourse) => void;
  course: ICourse;
}) => {

  const onSaveCourse = async (course: ICourse) => {
    const changes = ChangesService.getChanges(props.course, course);
    if (changes.detected) {
      const updatedCourse = await CourseStorageService.patchCourse(props.course.id, changes.changes);
      props.onCourseUpdated?.(updatedCourse);
    }
  };

  return (
    <CourseDialog
      onClose={props.onClose}
      course={props.course}
      onSave={onSaveCourse}
      title='Edit Course'
      saveLabel='Save'
      savingLabel='Saving...'
    />
  )
}